module.exports = __webpack_public_path__ + "img/tag_video.b2537059.png";